import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import * as Feather from 'feather-icons';

@Component({
  selector: 'app-logiciel-caisse-list-toolbar',
  templateUrl: './logiciel-caisse-list-toolbar.component.html',
  styleUrls: ['./logiciel-caisse-list-toolbar.component.scss'],
})
export class LogicielCaisseListToolbarComponent implements AfterViewInit {
  @Input() searchTerm = '';
  @Output() searchTermChange = new EventEmitter<string>();
  @Input() showSearch = true;
  @Input() primaryLabel = '';
  @Output() primaryClick = new EventEmitter<void>();

  constructor(private readonly cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.refreshFeatherIcons();
  }

  onSearchInput(value: string): void {
    this.searchTerm = value;
    this.searchTermChange.emit(value);
    this.refreshFeatherIcons();
  }

  onPrimary(): void {
    this.primaryClick.emit();
  }

  private refreshFeatherIcons(): void {
    setTimeout(() => {
      try {
        Feather.replace();
      } catch {
        /* noop */
      }
      this.cdr.markForCheck();
    }, 0);
  }
}
